import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { combineLatest, Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { PricingFeatureFacade } from '../../../types/pricing-feature.types';

@Injectable({
  providedIn: 'root',
})
export class ProductOrderParamsGuard {
  constructor(private facade: PricingFeatureFacade) {
    facade.fetchPlansIfNeeded();
  }

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return combineLatest([
      this.validateProduct(route.params.productId),
      this.validateInterval(route.params.interval),
      this.validateQuantity(route.params.quantity),
    ]).pipe(
      first(),
      map(results => results.every(r => r)),
    );
  }

  private validateProduct(paramId: string): Observable<boolean> {
    const id = parseInt(paramId, 10);
    return this.facade
      .getBillingPlansWithActive()
      .pipe(map(productsWithActive => productsWithActive.some(p => p.id === id)));
  }

  private validateInterval(interval: string | undefined) {
    return of(
      interval !== undefined ? ['1', '3', '6', '12', '24', '36'].includes(interval) : false,
    );
  }

  private validateQuantity(quantity: string | null | undefined) {
    if (quantity === undefined || quantity === null) return of(true);
    return of(parseInt(quantity, 10) > 0);
  }
}
